module.exports = __webpack_public_path__ + "img/duffle_thumb.6fc08801.jpg";